import React from 'react';

const AllClozeFeedback = ({
	correctAnswer,
	selectedAnswer,
	passage,
	delimiter,
}) => {
	let selectedAnswerList = selectedAnswer.trim().split(' ');
	const result = selectedAnswerList.filter((character) => character.length > 1);
	let correctAnswerList = [];
	if (result.length === 0) {
		correctAnswerList = correctAnswer.trim().split('');
	} else {
		correctAnswerList = correctAnswer.trim().split(' ');
	}

	let userFeedback =
		!!correctAnswerList &&
		correctAnswerList.map((phrase, i) => {
			return (
				<span key={`selected_${i}`}>
					{' '}
					{!!selectedAnswerList && !!selectedAnswerList[i] && (
						<span
							className={`${
								selectedAnswerList[i] === correctAnswerList[i] ? '' : 'text-danger'
							} `}
							data-id="15753593663"
						>
							{selectedAnswerList[i]}
						</span>
					)}{' '}
				</span>
			);
		});

	return (
		<div>
			<p className="pad-all mar-no">{userFeedback}</p>
		</div>
	);
};

export default AllClozeFeedback;
